export const TalentStatuses = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  LEAVE: 'leave',
  PREBOARDING: 'preboarding',
  ONBOARDING: 'onboarding',
};
